if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindCarouselEvents();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content [data-media-id]'));
      }

      getThumbnails() {
        return Array.from(this.querySelectorAll('.product-media-modal__thumbnail'));
      }

      showActiveMedia() {
        const items = this.getMediaItems();
        const activeMediaId = this.openedBy.getAttribute('data-media-id');

        items.forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === activeMediaId);
        });

        const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        this.currentIndex = items.indexOf(activeMedia);
        this.updateThumbnails(activeMediaId);
        this.updateArrowVisibility(items.length);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      updateThumbnails(activeMediaId) {
        const thumbnails = this.getThumbnails();
        thumbnails.forEach((thumb) => {
          const isActive = thumb.getAttribute('data-target-media-id') === activeMediaId;
          thumb.classList.toggle('active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
            thumb.scrollIntoView({ block: 'nearest', inline: 'center' });
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      updateArrowVisibility(itemCount) {
        const showArrows = itemCount > 1;
        const prev = this.querySelector('.product-media-modal__arrow--prev');
        const next = this.querySelector('.product-media-modal__arrow--next');
        if (prev) prev.style.display = showArrows ? '' : 'none';
        if (next) next.style.display = showArrows ? '' : 'none';
        const thumbnails = this.querySelector('.product-media-modal__thumbnails');
        if (thumbnails) thumbnails.style.display = showArrows ? '' : 'none';
      }

      goToIndex(index) {
        const items = this.getMediaItems();
        if (items.length === 0) return;
        const newIndex = (index + items.length) % items.length;
        const target = items[newIndex];
        const mediaId = target.getAttribute('data-media-id');

        items.forEach((element) => element.classList.toggle('active', element === target));
        this.currentIndex = newIndex;
        this.updateThumbnails(mediaId);
        target.scrollIntoView({ block: 'nearest' });

        if (target.nodeName === 'DEFERRED-MEDIA' && typeof target.loadContent === 'function') {
          target.loadContent(false);
        }
      }

      next() {
        this.goToIndex((this.currentIndex || 0) + 1);
      }

      prev() {
        this.goToIndex((this.currentIndex || 0) - 1);
      }

      bindCarouselEvents() {
        if (this.carouselBound) return;
        this.carouselBound = true;

        const prevButton = this.querySelector('.product-media-modal__arrow--prev');
        const nextButton = this.querySelector('.product-media-modal__arrow--next');
        if (prevButton) prevButton.addEventListener('click', () => this.prev());
        if (nextButton) nextButton.addEventListener('click', () => this.next());

        this.getThumbnails().forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const items = this.getMediaItems();
            const targetId = thumb.getAttribute('data-target-media-id');
            const index = items.findIndex((item) => item.getAttribute('data-media-id') === targetId);
            if (index > -1) this.goToIndex(index);
          });
        });

        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowRight') this.next();
          if (event.code === 'ArrowLeft') this.prev();
        });
      }
    }
  );
}
